import h from './contact-channels156.js';
import y from './contact-channels157.js';

function u(){var t=h(arguments),e=t.text,r=t.options,a=t.metadata;return y(e,r,a)}

export { u as default };
//# sourceMappingURL=contact-channels90.js.map
